import LogoMark from '@cartwhl/ui/atoms/LogoMark';
import Text from '@cartwhl/ui/base/Text';

export default function AuthPageLayout({
  children,
  title,
  subtitle,
}: {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
}) {
  return (
    <div className="mx-auto flex min-h-screen w-full max-w-[480px] flex-col justify-center px-8 py-10 xl:max-w-[576px] xl:px-20">
      <LogoMark className="mb-12 h-10 w-10 md:h-12 md:w-12" />
      {title && (
        <Text as="h1" variant="studio/display/xl" className="mb-6">
          {title}
        </Text>
      )}
      {subtitle && (
        <Text variant="studio/body/sm" className="text-tertiary mb-6">
          {subtitle}
        </Text>
      )}
      {children}
    </div>
  );
}
